import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useRetrieveTeam } from "../ApiProvider";
import { useRetrieveExternalMatch, useUpdateExternalMatch, } from "../api/MatchApiProvider";
import { useRetrieveUserExternalMatchPermissions } from "../api/PermissionApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { NotFound } from "../nav/NotFound";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
import { ExternalMatchForm } from "./ExternalMatchForm";
export const UpdateExternalMatch = () => {
    const { id } = useNumericParams();
    const { data: userExternalMatchPermissions, isLoading: userExternalMatchPermissionsIsLoading, error: userExternalMatchPermissionsError, } = useRetrieveUserExternalMatchPermissions({ externalMatchId: id });
    const { canModify = false } = userExternalMatchPermissions || {};
    const { isLoading: useRetrieveExternalMatchIsLoading, error: useRetrieveExternalMatchError, data: externalMatch, } = useRetrieveExternalMatch({ id, enabled: canModify });
    const { data: team, error: teamError, isLoading: teamIsLoading, } = useRetrieveTeam({ id: externalMatch?.team });
    const navigate = useNavigate();
    const mutation = useUpdateExternalMatch({
        id,
        team,
        onMutate: () => { },
        onSuccess: () => {
            return navigate(`/teams/${externalMatch?.team}/external-matches/${id}/`);
        },
        onError: () => { },
    });
    const onSubmit = (externalMatch) => {
        mutation.mutate(externalMatch);
    };
    if (userExternalMatchPermissionsIsLoading) {
        return _jsx(Loading, {});
    }
    if (userExternalMatchPermissionsError) {
        return _jsx(ErrorView, { error: userExternalMatchPermissionsError });
    }
    if (!canModify) {
        return _jsx(NotFound, {});
    }
    if ((useRetrieveExternalMatchIsLoading && canModify) || teamIsLoading) {
        return _jsx(Loading, {});
    }
    if (useRetrieveExternalMatchError ||
        !externalMatch?.team ||
        !team ||
        teamError) {
        return _jsx(ErrorView, { error: useRetrieveExternalMatchError });
    }
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: mutation.isError, message: "Failed to update External Match. Please try again." }), _jsx(Typography, { variant: "h6", children: _jsxs("strong", { children: ["Update External Match for ", team.name] }) }), _jsx(ExternalMatchForm, { externalMatch: externalMatch, team: team, onSubmit: onSubmit })] }));
};
